import React from "react";
import { Outlet } from "react-router-dom";
import '../../Assets/css/dashboard.css';
import '../../Assets/css/auth.css';

const SalesLayout = () => {
    return (
        <React.Fragment>
            <Outlet />
        </React.Fragment>
    )
}
export default SalesLayout;